import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ProfileService} from '../../../services/profile.service';
import {Contact} from '../../../model/contact';
import {FaqCategoryService} from '../../../services/faq-category.service';
import {FaqCategory} from '../../../model/FaqCategory';
import {Product} from '../../../model/product';
import {UserService} from '../../../services/user.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {UsersEditModalComponent} from "../users-edit-modal/users-edit-modal.component";
import {UserRequest} from "../../../model/UserRequest";

import {BreadcrumbComponent} from "../../../components/common/breadcrumb/breadcrumb.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {AffectedToStartedContractPipe} from "../../../components/common/AffectedToStartedContractPipe";
import {RouterLink} from "@angular/router";
import {BadgeComponent} from "../../../components/common/badge/badge.component";
import {FormsModule} from "@angular/forms";
import {DynamicModalFormComponent} from "../../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {DynamicTableComponent} from "../../../components/common/dynamic-table/dynamic-table.component";
import {SpinnerComponent} from "../../../components/common/spinner/spinner.component";

enum ActionAsked {
  none = '',
  enable = 'enable',
  remove = 'remove'
}

@Component({
    selector: 'app-users',
    imports: [
    BreadcrumbComponent,
    FaIconComponent,
    AffectedToStartedContractPipe,
    RouterLink,
    BadgeComponent,
    FormsModule,
    SpinnerComponent,
    DynamicModalFormComponent,
    DynamicTableComponent
],
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  readonly ActionAsked = ActionAsked;
  contacts: Contact[] = [];
  categories: FaqCategory[];
  requests: UserRequest[];

  sortfield = 'lastname';
  sortreverse = true;

  actionContact: Contact;
  actionType = '';
  actionAsked: ActionAsked = ActionAsked.none;

  tableHeaders = [
    { label: 'État', center: true },
    {
      label: 'Nom',
      sortable: true,
      property: 'lastname',
    },
    {
      label: 'Prénom',
      sortable: true,
      property: 'firstname',
    },
    {
      label: 'Adresse mail',
      sortable: true,
      property: 'email',
    },
    {
      label: 'Profil',
      sortable: true,
      property: 'referent',
      customSort: (a:Contact, b:Contact) => a.referent ? b.referent ? 0 : 1 : -1,
    },
    { label: 'Logiciels' },
  ];

  tableActions = [
    {
      icon: 'cog',
      eventHandler: (item: Contact) => {
        this.modifyUser(item);
      },
      cssClass: 'text-info',
      tooltip: 'Effectuer une demande de modification',
      condition: (item: Contact) => item.enabled
    },
    {
      icon: 'user-slash',
      eventHandler: (item: Contact) => {
        this.actionContact = item;
        this.actionAsked = ActionAsked.none;
        this.actionType = this.actionAsked.toString();
      },
      cssClass: 'text-warning',
      tooltip: 'Suspendre / Supprimer l\'utilisateur',
      condition: (item: Contact) => item.enabled
    },
    {
      icon: 'sync',
      eventHandler: (item: Contact) =>  {
        this.actionContact = item;
        this.actionAsked = ActionAsked.enable;
        this.actionType = this.actionAsked.toString();
      },
      cssClass: 'text-success',
      tooltip: 'Réactiver l\'utilisateur suspendu',
      condition: (item: Contact) => !item.enabled
    },
    {
      icon: 'user-slash',
      eventHandler: (item: Contact) => {
        this.actionContact = item;
        this.actionAsked = ActionAsked.remove;
        this.actionType = this.actionAsked.toString();
      },
      cssClass: 'text-danger',
      tooltip: 'Supprimer l\'utilisateur',
      condition: (item: Contact) => !item.enabled
    },
  ];

  modalActions = [
    {
      label: 'Confirmer',
      class: 'btn-primary disabled',
      icon: '',
      condition: () => this.actionType === ''
    },
    {
      label: 'Confirmer',
      longLabel: 'la suppression du compte',
      class: 'btn-danger',
      icon: '',
      condition: () => this.actionType === 'delete' || this.actionType === 'leaving'
    },
    {
      label: 'Confirmer',
      longLabel: 'la suspension du compte',
      class: 'btn-warning',
      icon: '',
      condition: () => this.actionType === 'suspend'
    },
    {
      label: 'Confirmer',
      longLabel: 'la réactivation du compte',
      class: 'btn-primary',
      icon: '',
      condition: () => this.actionType === 'enable'
    }
  ];

  rowCustomClass(): ((item: Contact) => string) {
    return (item: Contact): string => {
      if(!item.enabled) {
        return 'disabled';
      } else if(this.isUserUnderModification(item)) {
        return 'disabled under-modification';
      } else {
        return '';
      }
    }
  }

  rowTooltip(): ((item: Contact) => string) {
    return (item: Contact): string => {
      if(!item.enabled) {
        return 'Ce compte utilisateur est suspendu';
      } else if(this.isUserUnderModification(item)) {
        return 'Une demande de modification est en cours';
      } else {
        return '';
      }
    }
  }

  @ViewChild('handleaccountmodal') handleaccountmodal: TemplateRef<any>;
  @ViewChild('addproductmodal') addproductmodal: TemplateRef<any>;

  constructor(private profileService: ProfileService,
              private faqCategoryService: FaqCategoryService,
              private modalService: NgbModal,
              private userService: UserService,
              private toastr: ToastrService) {
  }

  ngOnInit(): void {
    this.userService.listEditRequests().subscribe(r => {
      this.requests = r;
    })
    this.faqCategoryService.getAllCategories().subscribe(cats => {
      this.categories = cats;
    });

    this.profileService.getProfile().subscribe(profile => {
      this.contacts = profile.contacts;
    });
  }

  isUserUnderModification(c: Contact): boolean {
    return this.requests?.filter(r => {
      return r.requestType === 'EDIT' && ("" + r.forContactId) === ("" + c.crmId);
    }).length > 0;
  }

  getCategoryFromProduct(p: Product): FaqCategory {
    return this.categories?.find(c => {
      return c.slug.toLowerCase() === p.tag.toLowerCase();
    });
  }

  updateSort(fieldname: string): void {
    if (this.sortfield === fieldname) {
      this.sortreverse = !this.sortreverse;
    } else {
      this.sortreverse = false;
      this.sortfield = fieldname;
    }
    const tmp = Object.assign([], this.contacts);
    this.contacts.length = 0;
    this.contacts = tmp;


  }

  modifyUser(c: Contact): void {
    if (this.isUserUnderModification(c)) {
      return;
    }
    const modalRef = this.modalService.open(UsersEditModalComponent, {size: 'lg', backdrop: 'static'});
    modalRef.componentInstance.user = c;
    modalRef.result.then(() => {
      this.userService.listEditRequests().subscribe(r => {
        this.requests = r;
      })
      this.toastr.info('La demande de modification a été envoyée');
    }).catch(() => {
    });
  }

  getModalTitleFromAction() : string {
    if(!this.actionContact) {
      return '';
    }
    let title: string;
    switch (this.actionAsked) {
      case ActionAsked.none:
        title = 'Suppression / Suspension';
        break;
      case ActionAsked.enable:
        title = 'Ré-activation';
        break;
      case ActionAsked.remove:
        title = 'Suppression';
        break;
    }
    return `${title} du compte de ${this.actionContact.firstname} ${this.actionContact.lastname}`;
  }

  handleConfirmAction(): void {
    switch (this.actionType) {
      case 'leaving':
        this.userService.removeUser(this.actionContact.crmId, true).subscribe(() => {
          this.contacts = this.contacts.filter(c1 => this.actionContact.crmId !== c1.crmId);
          this.toastr.info('Le compte a été supprimé');
          this.actionContact = undefined;
        });
        break;
      case 'delete':
        this.userService.removeUser(this.actionContact.crmId, false).subscribe(() => {
          this.contacts = this.contacts.filter(c1 => this.actionContact.crmId !== c1.crmId);
          this.toastr.info('Le compte a été supprimé du Portail client');
          this.actionContact = undefined;
        });
        break;
      case 'suspend':
        this.userService.disableUser(this.actionContact.crmId).subscribe(() => {
          this.actionContact.enabled = false;
          this.toastr.info('Le compte a été désactivé');
          this.actionContact = undefined;
        });
        break;
      case 'enable':
        this.userService.enableUser(this.actionContact.crmId).subscribe(() => {
          this.actionContact.enabled = true;
          this.toastr.info('Le compte a été réactivé. Un mail a été envoyé à l\'utilisateur l\'informant de la réactivation de son compte.');
          this.actionContact = undefined;
        });
        break;
      default:
    }
  }

  handleUser(c: Contact, action?: ActionAsked): void {
    if (this.isUserUnderModification(c)) {
      return;
    }
    this.actionContact = c;
    this.actionAsked = action || ActionAsked.none;
    this.actionType = this.actionAsked.toString();
    this.modalService.open(this.handleaccountmodal, {size: 'lg'}).result.then(() => {
      switch (this.actionType) {
        case 'leaving':
          this.userService.removeUser(c.crmId, true).subscribe(() => {
            this.contacts = this.contacts.filter(c1 => c.crmId !== c1.crmId);
            this.toastr.info('Le compte a été supprimé');
          });
          break;
        case 'delete':
          this.userService.removeUser(c.crmId, false).subscribe(() => {
            this.contacts = this.contacts.filter(c1 => c.crmId !== c1.crmId);
            this.toastr.info('Le compte a été supprimé du Portail client');
          });
          break;
        case 'suspend':
          this.userService.disableUser(c.crmId).subscribe(() => {
            c.enabled = false;
            this.toastr.info('Le compte a été désactivé');
          });
          break;
        case 'enable':
          this.userService.enableUser(c.crmId).subscribe(() => {
            c.enabled = true;
            this.toastr.info('Le compte a été réactivé. Un mail a été envoyé à l\'utilisateur l\'informant de la réactivation de son compte.');
          });
          break;
        default:
      }
    }).catch(() => {
    });
  }
}
